/**
 * 数据中心模块路由配置
 */
import Workbench from '../components/data/workbench/workbench';// 工作台路由组件
import Subjects from '../components/data/workbench/all/subjects/subjects';// 受试者组件
import PmpScaleForm from '../components/data/workbench/all/subjects/pmpScaleForm/PmpScaleForm';// PMP 量表记录页（eproUrl=1）
import BatchCaseRewiew from '../components/data/batchCaseRewiew';// 批量病例审核
import MessageHome from '../components/data/message/Home';// 批量病例审核
import DataBoard from '../components/data/data-board';

const routes = [
    { 'path': '/data/workbench', 'component': Workbench },
    { 'path': '/data/workbench/all/subjects', 'component': Subjects },
    { 'path': '/data/workbench/all/subjects/pmp-scale', 'component': PmpScaleForm },
    { 'path': '/data/batch/audit', 'component': BatchCaseRewiew },
    { 'path': '/data/message', 'component': MessageHome },
    { 'path': '/data/board/list', 'component': DataBoard },
];

export default routes
